/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DesignHomePageLayout } from 'app/shared/models/design-home-page-layout';
import { LayoutPickerComponent } from './layout-picker.component';
const customValueProvider = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => TicketShopLayoutPickerComponent),
	multi: true,
};
const customValidateProvider = {
	provide: NG_VALIDATORS,
	useExisting: forwardRef(() => TicketShopLayoutPickerComponent),
	multi: true,
};
@Component({
	selector: 'ticket-shop-layout-picker',
	templateUrl: './layout-picker.component.html',
	styleUrls: ['./ticket-shop-layout-picker.component.scss'],
	providers: [customValueProvider, customValidateProvider],
	standalone: false,
})
export class TicketShopLayoutPickerComponent extends LayoutPickerComponent {
	

	getIcons(id: number): string[] {
		switch (id) {
			case 1:
				return ['view_headline'];
			case 2:
				return ['check_box_outline_blank'];
			case 3:
				return ['window'];
			case 4:
				return ['grid_on'];
			case 5:
				return ['background_grid_small'];
			default:
				return [];
		}
	}

	getTooltip(id: number): string {
		switch (id) {
			case 1:
				return 'List';
			case 2:
				return 'Panels: One column';
			case 3:
				return 'Panels: Two columns';
			case 4:
				return 'Panels: Three columns';
			case 5:
				return 'Panels: Four columns';
			default:
				return '';
		}
	}
}
